<div id="image-section">
  <img id="error-image" src="{{errorInfo.imagePath}}">
</div>
<div class="basic-font-medium" id="message-section">
  <span style="min-height: 40px;white-space: pre-line;">{{ errorInfo.message }}</span>
  <button mat-raised-button *ngIf="errorInfo.showReloadButton" id="reload-button" (click)="reload()">{{ 'RECOVERY.RELOAD' | translate }}</button>
</div>
